export default __webpack_public_path__ + "static/media/newvideo.13f8e427.mp4";